module.exports = __webpack_public_path__ + "static/img/deatop.708cfdc8.jpg";